type ProfileIdentitySource = {
  firstname?: unknown;
  lastname?: unknown;
  name?: unknown;
  fullName?: unknown;
};

function cleanName(value: unknown): string {
  return typeof value === "string" ? value.normalize("NFC").trim().replace(/\s+/g, " ") : "";
}

export default function getProfileIdentity(
  data: ProfileIdentitySource | null | undefined,
  fallbackName: string,
) {
  const name = [cleanName(data?.firstname), cleanName(data?.lastname)].filter(Boolean).join(" ")
    || cleanName(data?.fullName) || cleanName(data?.name);
  const parts = name.split(" ").filter(Boolean);
  const first = Array.from(parts[0] || "")[0] || "";
  const last = parts.length > 1 ? Array.from(parts[parts.length - 1])[0] : "";

  return {
    name: name || fallbackName,
    initials: (first + last).toLocaleUpperCase() || "?",
  };
}

// Keep the same public image hosts/protocol as next.config.js. A malformed or
// unsupported profile URL is missing media, not a reason to lose account access.
export function getProfilePhotoSource(
  value: unknown,
  hosts: Array<string | undefined>,
  protocol: string | undefined,
): string | null {
  if (typeof value !== "string" || !value.trim()) return null;
  const source = value.trim();
  if (source.startsWith("/") && !source.startsWith("//")) return source;
  try {
    const url = new URL(source);
    return (url.protocol === "http:" || url.protocol === "https:")
      && url.protocol === `${protocol}:`
      && !url.username && !url.password
      && hosts.some((host) => host && host.toLowerCase() === url.hostname.toLowerCase())
      ? source : null;
  } catch {
    return null;
  }
}
